import {getApi} from '../../modules/common/utils/api'

const api = getApi('reservation')

export function postCalendarView(data) {
  return api.post(`/v1/calendar_views`, data)
}

export function putCalendarView(data) {
  return api.put(`/v1/calendar_views`, data)
}

export function deleteCalendarView(data) {
  return api.delete(`/v1/calendar_views`, {data})
}

export function postCalendarChildView(data) {
  return api.post(`/v1/calendar_child_views`, data)
}

export function putCalendarChildView(data) {
  return api.put(`/v1/calendar_child_views`, data)
}

export function deleteCalendarChildView(data) {
  return api.delete(`/v1/calendar_child_views`, {data})
}

export function getCalendarViews(user_id) {
  return api.post(`/v1/calendar_views/user_views`, {user_id: user_id})
}
